import swal from 'sweetalert2'

export function parseHasEnrolledUsers (response) {
  if (!response || !response.status) return null
  let d = response.data
  if (d != null && typeof d === 'object' && d.data != null && typeof d.data !== 'string') {
    d = d.data
  }
  if (typeof d === 'boolean') return d
  if (d == null) return false
  if (typeof d === 'object') {
    if (typeof d.has_enrolled_users === 'boolean') return d.has_enrolled_users
    if (typeof d.hasEnrolledUsers === 'boolean') return d.hasEnrolledUsers
    if (typeof d.enrolled === 'boolean') return d.enrolled
    if (typeof d.count === 'number') return d.count > 0
  }
  return false
}

function sessionPayload (vm) {
  return {
    token: vm.$session.get('token'),
    company_id: vm.$session.get('selectedCompany')
  }
}

function requestHasEnrolledUsers (vm, campaignId, callback) {
  vm.apiRequest(
    '/referral-campaign/' + campaignId + '/has-enrolled-users',
    'GET',
    sessionPayload(vm),
    callback
  )
}

function performDelete (vm, campaignId, onDeleted) {
  vm.apiRequest('/referral-campaign/' + campaignId, 'DELETE', sessionPayload(vm), (response) => {
    if (response.status) {
      if (typeof onDeleted === 'function') onDeleted(response)
    } else {
      swal('', vm.$t('validations.wentWrong'), 'error')
    }
  })
}

function performDeactivate (vm, campaignId, buildBody, onDeactivated) {
  const body = Object.assign(
    {},
    typeof buildBody === 'function' ? buildBody() : {},
    sessionPayload(vm),
    { active: false, is_visible_for_users: false }
  )
  vm.apiRequest('/referral-campaign/' + campaignId, 'PUT', body, (response) => {
    if (response.status) {
      swal(vm.$t('general.success') + '!', '', 'success').catch(() => {})
      if (typeof onDeactivated === 'function') onDeactivated(response)
    } else {
      const msg = (response.errors && (response.errors.message || response.errors[0])) || vm.$t('validations.wentWrong')
      swal('', msg, 'error')
    }
  })
}

function showCannotDeleteSwal (vm, campaignId, options) {
  swal({
    text: vm.$t('referralProgram.cannotDeleteHasEnrolledUsers'),
    type: 'error',
    showCancelButton: true,
    confirmButtonText: vm.$t('referralProgram.deactivateCampaign'),
    cancelButtonText: vm.$t('general.cancel')
  }).then((result) => {
    if (!result) return
    performDeactivate(vm, campaignId, options.buildDeactivateBody, options.onDeactivated)
  }).catch(() => {})
}

export function attemptReferralCampaignDelete (vm, campaignId, options = {}) {
  if (campaignId == null || campaignId === '') return

  requestHasEnrolledUsers(vm, campaignId, (checkResponse) => {
    if (!checkResponse.status) {
      swal('', vm.$t('validations.wentWrong'), 'error')
      return
    }

    const hasEnrolled = parseHasEnrolledUsers(checkResponse)
    if (hasEnrolled === null) {
      swal('', vm.$t('validations.wentWrong'), 'error')
      return
    }

    if (hasEnrolled) {
      showCannotDeleteSwal(vm, campaignId, options)
      return
    }

    swal({
      text: vm.$t('general.generalAreYouSure'),
      type: 'question',
      showCancelButton: true,
      confirmButtonText: vm.$t('general.yes')
    }).then((result) => {
      if (!result) return
      performDelete(vm, campaignId, options.onDeleted)
    }).catch(() => {})
  })
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Marketing/Referral/referralCampaignDelete.js